import type { MenuProps } from "antd";
import type { NavigateFunction } from "react-router-dom";
import {
  CustomerServiceOutlined,
  FlagOutlined,
  IdcardOutlined,
  LogoutOutlined,
  SafetyCertificateOutlined,
  ShoppingOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { globalModel } from "../../global/GlobalModel";

export type ShellUserDropdownMenuOpts = {
  navigate: NavigateFunction;
  /** 「与我相关的空间」弹框 */
  onFollowsClick: () => void;
  /** 平台客服弹框 */
  onCustomerServiceClick: () => void;
};

/** 全站统一的顶栏／空间顶栏头像下拉菜单定义 */
export function shellUserDropdownMenu(
  opts: ShellUserDropdownMenuOpts
): MenuProps {
  const { navigate, onFollowsClick, onCustomerServiceClick } = opts;

  const items: MenuProps["items"] = [
    { key: "profile", label: "个人资料", icon: <IdcardOutlined /> },
    { key: "switch", label: "我的关注", icon: <UnorderedListOutlined /> },
    { key: "orders", label: "我的订单", icon: <ShoppingOutlined /> },
    { key: "benefits", label: "我的权益", icon: <SafetyCertificateOutlined /> },
    { key: "customer-service", label: "平台客服", icon: <CustomerServiceOutlined /> },
  ];

  if (globalModel.financeShareEnabled) {
    items.push({ key: "my-reports", label: "我的举报", icon: <FlagOutlined /> });
  }

  items.push({ type: "divider" });
  items.push({
    key: "logout",
    label: "退出登录",
    icon: <LogoutOutlined />,
    danger: true,
  });

  return {
    items,
    onClick: ({ key }) => {
      if (key === "profile") {
        globalModel.openProfileEditor();
        return;
      }
      if (key === "switch") {
        onFollowsClick();
        return;
      }
      if (key === "orders") {
        navigate("/orders");
        return;
      }
      if (key === "benefits") {
        navigate("/benefits");
        return;
      }
      if (key === "customer-service") {
        onCustomerServiceClick();
        return;
      }
      if (key === "my-reports") {
        navigate("/my-reports");
        return;
      }
      if (key === "logout") {
        void globalModel.logout().then(() => navigate("/"));
      }
    },
  };
}
